import { 
  getEventsByUserLogic, 
  createEventLogic 
} from "./Events.logic";
import { 
  saveListEventsByUser, 
  saveCountEvents 
} from "../Infrastructure/Events.store";

export async function getEventsByUser(id) {
  const { resources, count } = await getEventsByUserLogic(id);
  saveListEventsByUser(resources || []);
  saveCountEvents(count || 0);
}

export async function createEvent(eventData) {
  return createEventLogic(eventData);
}